var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex flex-column flex-root" }, [
    _c(
      "div",
      {
        staticClass: "d-flex flex-column flex-lg-row flex-row-fluid bg-white",
        attrs: { id: "appointment_action_wrapper" },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column-fluid flex-center mt-30 mt-lg-0",
              },
              [
                _c("div", [
                  _c("div", { staticClass: "appointment-action-card" }, [
                    _c("div", { staticClass: "text-center mb-10 mb-lg-20" }, [
                      _c("div", { staticClass: "logo" }, [
                        _c("img", {
                          attrs: { src: _vm.logoPath, alt: "bookybook" },
                        }),
                      ]),
                      _vm.state === "loading"
                        ? _c("div", { staticClass: "state-block" }, [
                            _c("div", {
                              staticClass: "spinner spinner-primary",
                            }),
                            _c("h1", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("appointmentActions.approve.loading")
                                  ) +
                                  " "
                              ),
                            ]),
                          ])
                        : _vm.state === "success"
                        ? _c("div", { staticClass: "state-block" }, [
                            _c(
                              "svg",
                              {
                                staticClass: "result-icon success",
                                attrs: {
                                  width: "64",
                                  height: "64",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "12",
                                    cy: "12",
                                    r: "11",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M7 12.5L10.5 16L17 8.5",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                            _c("h1", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("appointmentActions.approve.success")
                                  ) +
                                  " "
                              ),
                            ]),
                          ])
                        : _c("div", { staticClass: "state-block" }, [
                            _c(
                              "svg",
                              {
                                staticClass: "result-icon error",
                                attrs: {
                                  width: "64",
                                  height: "64",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "12",
                                    cy: "12",
                                    r: "11",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M8 8L16 16M16 8L8 16",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                  },
                                }),
                              ]
                            ),
                            _c("h1", [_vm._v(_vm._s(_vm.errorMessage))]),
                          ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }